<template>
	<div class="w-full">
        <div class="w-full flex flex-col">
            <div class="grid grid-cols-4 gap-6">
                <div class="col-span-2 row-span-2">
                    <div class="p-6 grid grid-cols-2 gap-6 bg-gray-200 border rounded">
                        <div class="flex flex-col">
                            <label for="subsidiary_id">
                                Subsidiary
                            </label>
                            <select
                                name="subsidiary_id"
                                class="mt-1 form-select block w-full text-xl"
                                v-model="site.subsidiary_id"
                            >
                                <option value=""></option>
                                <option v-for="subsidiary in site.client.subsidiaries" :key="subsidiary.id" :value="subsidiary.id">{{ subsidiary.name }}</option>
                            </select>
                        </div>

                        <div class="mt-3 col-span-2 leading-8 font-variant-all-small-caps uppercase">
                            <div>
                                <p class="text-3xl font-extrabold">{{ subsidiary.address }}</p>
                                <p class="text-2xl">
                                    <span>{{ subsidiary.city }}, {{ subsidiary.state }}  {{ subsidiary.postal_code }}</span>
                                </p>
                                <p class="text-lg">{{ subsidiary.country.name }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex flex-col">
                    <label for="lease_or_own">
                        Leased or Owned
                    </label>
                    <select
                        name="lease_or_own"
                        class="mt-1 form-select block w-full text-xl"
                        v-model="site.lease_or_own"
                    >
                        <option value="Leased">Leased</option>
                        <option value="Owned">Owned</option>
                    </select>
                </div>
            </div>
            <button @click.prevent="save" type="button" class="mt-5 self-end btn btn-green">Save Site</button>
        </div>
	</div>
</template>

<script>
    export default {
    	props: {
    		siteData: {
    			type: Object,
    			required: true
    		}
    	},

    	data() {
    		return {
    			site: this.siteData,

                states: {},
                countries: {},
    		}
    	},

        mounted() {
            this.site._method = "PATCH";

            this.initAddressInfo();
        },

        computed: {
            subsidiary() {
                return _.find(this.site.client.subsidiaries, ['id', this.site.subsidiary_id]);
            }
        },

        methods: {
            initAddressInfo() {
                axios.get('/api/address-info').then((response) => {
                    this.states = response.data.states;
                    this.countries = response.data.countries;
                }).catch((error) => {
                    console.log(error);
                });
            },

            save() {
                if (! this.isValidAllocation) {
                    this.$notify({
                        type: 'error',
                        title: 'Error',
                        text: 'Allocated Space is Invalid'
                    });

                    return;
                }

                axios.post('/sites/' + this.site.id, this.site)
                    .then(response => {
                        console.log(response);
                        this.$emit('site-updated', response.data.site);

                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: response.data.message
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        this.$notify({
                            type: 'error',
                            title: 'Error',
                            text: error.response.data.message
                        });
                    });
            }
        }
    }
</script>